import { InjectedConnector } from '@web3-react/injected-connector'
const selectedNetWorks = [56, 97]
const injected = new InjectedConnector({ supportedChainIds: selectedNetWorks })

export { selectedNetWorks, injected }